import { Stack, Typography } from "@mui/material"
import Image from "components/Image"
import React, { useCallback, useContext, useMemo } from "react"
import { Trans } from "react-i18next"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
// import { theme } from "themes/default/theme";

export const GlobalAlertContext = React.createContext()
export const useGlobalAlert = () => {
  // get the context
  const context = useContext(GlobalAlertContext)
  // if the context is undefined, throw an error
  if (context === undefined) {
    throw new Error("useGlobalAlert must be used within a GlobalAlertProvider")
  }
  // return the context
  return context
}

const GlobalAlertProvider = ({ children }) => {
  const MySwal = withReactContent(Swal)

  const showAlert = useCallback((message, customImage, onClose) => {
    MySwal.fire({
      html: (
        <Stack
          p={1.25}
          alignItems={"center"}
          justifyContent={"center"}
          spacing={1}
        >
          <Image
            src={customImage || require("../assets/img/common/maestra-01.png")}
            alt="warning"
            width={80}
            height={80}
            sx={{ borderRadius: "50%" }}
          />
          <Typography variant="span" sx={{ whiteSpace: "break-spaces" }}>
            {message}
          </Typography>
        </Stack>
      ),
      customClass: {
        container: "global-alert-swal",
      },
      padding: "0px",
      confirmButtonText: <Trans i18nKey={"accept"}>{"accept"}</Trans>,
    }).then((result) => {
      if (onClose) {
        onClose(result)
      }
    })
  }, [])

  const value = useMemo(
    () => ({
      showAlert,
    }),
    [showAlert]
  )

  return (
    <GlobalAlertContext.Provider value={value}>
      {children}
    </GlobalAlertContext.Provider>
  )
}

export default GlobalAlertProvider
